import { useMutation } from "@tanstack/react-query";
import { selfHireService } from "../services/selfHireService";
import { useToast } from "@/view/components/ui/use-toast";

// AUTO CONTRATAÇÃO DO FGTS
type getPublicCreditParams = {
  cpf: string
  phone?: string
  birthDate: string
  linkName: string
  prazo?: number
  leadId?: string
}

export function useFGTSMutations() {
  const { toast } = useToast();

  const simulateFGTSMutation = useMutation({
    mutationFn: (data: getPublicCreditParams) =>
      selfHireService.publicCredit(data.cpf, {
        birthDate: data.birthDate,
        linkName: data.linkName,
        prazo: data.prazo,
        leadId: data.leadId,
      }),
  })

  const createCustomerFGTSMutation =  useMutation({
    mutationFn: selfHireService.createPublicCustomer,
      onError: () => {
        toast({
          variant: "destructive",
          title: "Erro ao fazer o saque",
          description: "Verifique os dados e tente novamente.",
        });
      },
  })

  const createTransactionFGTSMutation = useMutation({
    mutationFn: selfHireService.createFGTSTransaction,
    onError: () => {
      toast({
        variant: "destructive",
        title: "Erro ao fazer o saque",
        description: "Tente novamente mais tarde.",
      });
    },
  })

  return {
    simulateFGTSMutation,
    createCustomerFGTSMutation,
    createTransactionFGTSMutation,
  };
}